import FingerprintJS from "@fingerprintjs/fingerprintjs";

let fingerprint: string | undefined = undefined;

export function useVisitorFingerprint() {
  const getFingerprint = async (): Promise<string> => {
    if (fingerprint === undefined) {
      const fp = await FingerprintJS.load();
      const data = await fp.get();
      fingerprint = data.visitorId;
    }
    return fingerprint;
  };

  return { getFingerprint };
}
